import { render, staticRenderFns } from "./UPreRegister.vue?vue&type=template&id=4c00c0a0&scoped=true&"
import script from "./UPreRegister.vue?vue&type=script&lang=ts&"
export * from "./UPreRegister.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c00c0a0",
  null
  
)

export default component.exports